import { createSelector } from 'reselect';

import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { ContentOfType } from 'commonTypes/api/scenarios/scenario';

import { getScenarioContent } from 'entities/scenario';

export const getOfferInfoData = createSelector(getScenarioContent, (content) => {
  const { offerInfo } = content as ContentOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>;
  return { ...offerInfo, summaries: offerInfo?.summaries?.map(({ text, value }) => ({ label: text, value })) || [] };
});
